// @flow
import React from 'react';
import gql from 'graphql-tag';
import Breadcrumbs from '@homeaway/react-breadcrumbs';

import type {DestinationShape} from '../../queries/searchQuery';

import './Breadcrumb.less';

type Props = {
    destination: ?DestinationShape
};

const commonSelectionSet = `
    destination {
        breadcrumbs {
            name
            url
        }
    }
`;

export const fragments = {
    results: gql`
        fragment DestinationBreadcrumbsResults on Results {
            ${commonSelectionSet}
        }
    `,
    searchResult: gql`
        fragment DestinationBreadcrumbsSearchResult on SearchResult {
            ${commonSelectionSet}
        }
    `
};

export default (props: Props) => {
    const {breadcrumbs = []} = props.destination || {};
    return (
        !!breadcrumbs.length && (
            <div className="breadcrumb">
                <div className="breadcrumb__container">
                    <Breadcrumbs crumbs={breadcrumbs} isLastCrumbLinked />
                </div>
            </div>
        )
    );
};
